/*
 *  Video Reviews Carousel
 *    Scripts for the video reviews carousel
 *
 *  Version:
 *    1.0.0 - 2024/06/24
 */

import {
  initCarousel,
  CarouselOptions,
  InitCarouselParams,
} from '../../objects/carousel';
import { CLASS_INITIALISED } from '../../tools/constants/classes';

// Selectors
const SELECTOR_SECTION = '[data-featured-video-reviews]';
const SELECTOR_CAROUSEL = '[data-featured-video-reviews-carousel]';
const SELECTOR_NAVIGATION = '[data-carousel-navigation]';
const SELECTOR_NAVIGATION_PREV = '[data-carousel-previous]';
const SELECTOR_NAVIGATION_NEXT = '[data-carousel-next]';
const SELECTOR_REVIEW_NAVIGATION_PREV = '[data-featured-video-review-prev]';
const SELECTOR_REVIEW_NAVIGATION_NEXT = '[data-featured-video-review-next]';

document
  .querySelectorAll<HTMLElement>(SELECTOR_SECTION)
  .forEach((container) => {
    // Check if section has already been initialized
    if (container.classList.contains(CLASS_INITIALISED)) return;
    container.classList.add(CLASS_INITIALISED);

    const carousel = container.querySelector<HTMLElement>(SELECTOR_CAROUSEL);
    const navigation = container.querySelector<HTMLElement>(SELECTOR_NAVIGATION);
    const carouselPrevControl = container.querySelector<HTMLElement>(SELECTOR_NAVIGATION_PREV);
    const carouselNextControl = container.querySelector<HTMLElement>(SELECTOR_NAVIGATION_NEXT);
    const reviewPrevControls = container.querySelectorAll<HTMLElement>(SELECTOR_REVIEW_NAVIGATION_PREV);
    const reviewNextControls = container.querySelectorAll<HTMLElement>(SELECTOR_REVIEW_NAVIGATION_NEXT);

    if (!carousel || !navigation) return;

    reviewPrevControls.forEach((reviewPrevControl) => {
      reviewPrevControl.addEventListener('click', () => {
        carouselPrevControl.click()
      })
    })

    reviewNextControls.forEach((reviewNextControl) => {
      reviewNextControl.addEventListener('click', () => {
        carouselNextControl.click()
      })
    })

    // Set carousel options
    const options: CarouselOptions = {
      slides: {
        perView: 1,
        origin: 'center',
      },
      loop: true,
      defaultAnimation: {
        duration: 1000,
      },
    };

    // Set carousel parameters
    const params: InitCarouselParams = {
      container: carousel,
      navigationContainer: navigation,
      options,
    };

    // Initialize carousel
    initCarousel(params);
  });